import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { push } from 'redux-first-history';

import MainFont from 'ui/typography/mainFont';

import routes from '../../../routing/routes';

import {
  Energy,
  MostUsedContent,
  MostUsedHeader,
  MostUsedItem,
  MostUsedTitle,
  MostUsedWrapper,
  Name,
  Ranking
} from './style';

const MostUsedRanking = ({ ranking, pushUrl, role }) => {
  const { t } = useTranslation();

  const goToCharger = chargerName => {
    pushUrl(`${routes.chargers.path}/${chargerName}`);
  };

  return (
    <MostUsedWrapper>
      <MostUsedHeader>
        <MostUsedTitle>
          <MainFont configuration={{ fontSize: 12 }}>#</MainFont>
        </MostUsedTitle>
        <MostUsedTitle>
          <MainFont configuration={{ fontSize: 12 }}>{t('name')}</MainFont>
        </MostUsedTitle>
        <MostUsedTitle className="kwh">
          <MainFont configuration={{ fontSize: 12 }}>{t('kwh')}</MainFont>
        </MostUsedTitle>
      </MostUsedHeader>
      <MostUsedContent>
        {ranking?.map((item, index) => (
          <MostUsedItem key={index}>
            <Ranking>
              <MainFont configuration={{ fontSize: 12 }}>{index + 1}</MainFont>
            </Ranking>
            <Name
              onClick={() => {
                goToCharger(item.name);
              }}
            >
              <MainFont configuration={{ fontSize: 14 }}>{item.name}</MainFont>
            </Name>
            <Energy>
              <MainFont configuration={{ fontSize: 12 }}>
                {item.energyProvided}
              </MainFont>
            </Energy>
          </MostUsedItem>
        ))}
      </MostUsedContent>
    </MostUsedWrapper>
  );
};

MostUsedRanking.propTypes = {
  ranking: PropTypes.array,
  pushUrl: PropTypes.func,
  role: PropTypes.string
};

export default connect(
  state => ({ role: state?.authentication?.accountInfo?.role }),
  dispatch => ({
    pushUrl: url => dispatch(push(url))
  })
)(MostUsedRanking);
